import React from 'react';
import { Row, Col, Icon } from 'antd'
import icon from '../../images/fileicon.png'
import logo from '../../images/logos/trackerapps.png'
import { PDFExport } from '@progress/kendo-react-pdf';

const  moment = require('moment');

class PDFLayout extends React.Component {

  shortenText = (text) => {
    if (text && text.length > 35 ) {
      return  text.slice(0, 35)+'...'
    }
    return text;
  }

  render() {

    const { logs, selected, color, t } = this.props

    const styles = {
      box: {
        backgroundColor: 'white',
        boxShadow: '0 2px 8px 0 rgba(0,0,0,0.16)',
        borderRadius: 10,
        padding: 20,
        marginBottom: 10,
        position: 'relative',
        width: 515,
        display: 'inline-block',
        border: `1px solid ${color}`
      },
      title: {
        color: color,
        fontSize: 12,
        marginBottom: 0,
        fontWeight: 'bold'
      },
      name: {
        color: color,
        fontSize: 12,
        marginBottom: 30,
        fontWeight: 'bold'
      },
      entry: {
        color: 'black',
        fontSize: '6pt',
        marginBottom: 10,
        wordBreak: 'break-all',
        letterSpacing: '1px'
      },
      date: {
        backgroundColor: color,
        borderRadius: '10px 10px 0px 0px',
        color: 'white',
        fontFamily: 'Arial Rounded MT Bold',
        fontSize: 15,
        textAlign: 'center',
        margin: '-20px -20px 20px -20px',
        paddingTop: 5
      },
      fileIcon: {
        width: 40,
        borderRadius: '50%',
        backgroundColor: color,
        border: '1px solid white',
        padding: 7,
        cursor: 'pointer',
        marginRight: 20
      },
      attachment: {
        display: 'flex',
        alignItems: 'top'
      },
    }

    const exports = []
    selected.map( log => {
      const item = logs[log]
      exports.push(item)
    })
// A4 HEIGHT : 784px
    return (
        <Row id='toExport' style={{ position: "absolute", left: '-1000px', top: 0 }}>
        <style>{style}</style>
          <PDFExport
            paperSize={'A4'}
            fileName="Skill Export.pdf"
            title=""
            ref={(r) => this.toExport = r}>
            <div style={{width: 555, padding: 20}}>
              <div style={{borderRadius: 3, border: `1px solid ${color}`, height: 160, marginBottom: 20, paddingTop: 20}}>
                <Col xs={6} style={{paddingLeft: 10, paddingRight: 10}}>
                  <img style={{width: '80%', height: 'auto', marginRight: 20}} src={logo} />
                </Col>
                <Col xs={15} >
                  <h3 style={styles.name}>{`${this.props.profile.profile.name} ${this.props.profile.profile.last_name}`}</h3>
                  <h3 style={styles.entry}>{this.props.profile.profile.email}</h3>
                  <h3 style={styles.entry}>{this.props.profile.profile.school.name}</h3>
                  <h3 style={styles.entry}>{`Exported on ${this.props.moment().format('DD.MM.YYYY')}`}</h3>
                </Col>
              </div>
              {exports && exports.map( log => (
                  <div style={styles.box}>
                    <div style={styles.date}>{moment(log.date).format('DD-MM-YY')}</div>
                    <Col xs={8}>
                      <h3 style={styles.title}>{t('Class')}</h3>
                      <p style={styles.entry}>{log.className}</p>
                      <h3 style={styles.title}>{t('Title of Work')}</h3>
                      <p style={styles.entry}>{log.title}</p>
                      <h3 style={styles.title}>{t('Skill Category')}</h3>
                      <p style={styles.entry}>{t(log.category)}</p>
                    </Col>
                    <Col xs={6}>
                      <h3 style={styles.title}>{t('ATL Cluster')}</h3>
                      <p style={styles.entry}>{t(log.cluster)}</p>
                      <h3 style={styles.title}>{t('Skill level')}</h3>
                      <p style={styles.entry}>{t(log.skill)}</p>
                      <h3 style={styles.title}>{t('Notes')}</h3>
                      <p style={styles.entry}>{log.notes}</p>
                    </Col>
                    <Col xs={10}>
                      {Array.isArray(log.attachments) &&
                      <div>
                        <h3 style={styles.title}>{t('Attachments')}</h3>
                        <div>
                          {log.attachments.map( attachment =>
                              <p style={styles.entry}>{this.shortenText(attachment.name)}</p>
                          )}
                        </div>
                      </div>
                      }
                    </Col>
                  </div>
                ))}
              </div>
            </PDFExport>
      </Row>
    )
  }
}

export default PDFLayout;

const style =
  `@font-face {
      font-family: "DejaVu Sans";
      src: url("https://kendo.cdn.telerik.com/2017.2.621/styles/fonts/DejaVu/DejaVuSans.ttf") format("truetype");
  }
  h3 {
    font-family: 'DejaVu Sans !important';
  }`



// WEBPACK FOOTER //
// ./src/components/PDFLayout/index.jsx